import React, {useState, useEffect, useRef} from "react";
import createFormImage from "../../../assets/images/icons/surveys/form-upload-image.svg";
import SelectField from "../../forms/selectOption";
import copyForm from "../../../assets/images/icons/surveys/copy-form.svg"
import deleteQuestion from "../../../assets/images/icons/surveys/deleteQuestion.svg"
import { getAllQuestionFormats } from "../../../client/surveys";
import BranchModal from "../../shared/modals/branchModal";

const QuestionCardAdmin = ({ 
  questionData = null, 
  onDelete, 
  onCopy,
  showDeleteButton = true,
  onUpdate,
  hideBranchButtons = false,
  isBranchModal = false,
  isEditing = false,
}) => {
  
  const [isRequired, setIsRequired] = useState(questionData?.isRequired || false);
  const [options, setOptions] = useState([
    { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
    { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
  ]);
  //selección única
  const [selectedOption, setSelectedOption] = useState(null);
  //selección múltiple
  const [selectedOptions, setSelectedOptions] = useState([]);

  //imagen pregunta
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [questionTitle, setQuestionTitle] = useState(questionData?.questionTitle || "");

  const [questionFormats, setQuestionFormats] = useState([]); 
  const [selectedFormat, setSelectedFormat] = useState(2); 

  const [branches, setBranches] = useState({}); 
  const [hasOtherOption, setHasOtherOption] = useState(questionData?.hasOtherOption || false);

  const fileInputRef = useRef(null);
//modal rama
  const [branchModalOpen, setBranchModalOpen] = useState(false);
  const [editingOptionId, setEditingOptionId] = useState(null);
  const [existingBranches, setExistingBranches] = useState({});

const openCreateBranchModal = (optionId) => {
  setEditingOptionId(optionId);
  
  
  setTimeout(() => {
    setBranchModalOpen(true);
  }, 10);
};

useEffect(() => {
  const syncExistingBranches = {};
  Object.entries(branches).forEach(([optionId, branchArray]) => {
    if (Array.isArray(branchArray) && branchArray.length > 0) {
      syncExistingBranches[optionId] = branchArray[0];
    }
  });
  setExistingBranches(syncExistingBranches);
}, [branches]);

  useEffect(() => {
    if (questionData) {
      setIsRequired(questionData.isRequired || false);
      setOptions(questionData.options || [
        { id: 1, text: "", placeholder: "Opción 1", isAddOption: false, isOtherOption: false },
        { id: 2, text: "", placeholder: "Agregar una opción", isAddOption: true, isOtherOption: false },
      ]);
      setSelectedOption(questionData.selectedOption || null);
      setSelectedOptions(questionData.selectedOptions || []);
      setUploadedImage(questionData.uploadedImage || null);
      setImagePreview(questionData.imagePreview || null);
      setQuestionTitle(questionData.questionTitle || "");
      setSelectedFormat(questionData.selectedFormat || 2);

    setHasOtherOption(questionData.hasOtherOption !== undefined ? questionData.hasOtherOption : false);

    
      if (questionData.branches) {
        setBranches(questionData.branches);
      }
      
      if (questionData.existingBranches) {
        setExistingBranches(questionData.existingBranches);
      } else {
        const syncExistingBranches = {};
        Object.entries(questionData.branches || {}).forEach(([optionId, branchArray]) => {
          if (Array.isArray(branchArray) && branchArray.length > 0) {
            syncExistingBranches[optionId] = branchArray[0];
          }
        });
        setExistingBranches(syncExistingBranches);
      }
    }
  }, [questionData]);
  

const canShowAddBranchButton = (optionId) => {
  const option = options.find(opt => opt.id === optionId);
  return option && !option.isAddOption && !option.isOtherOption;
};

const handleSaveBranch = (branchQuestions) => {
  
  const updatedBranches = { ...branches };
  
  updatedBranches[editingOptionId] = branchQuestions.map((branch, index) => ({
    id: branch.id,
    data: branch.data,
    order: index + 1
  }));
  
  
  setBranches(updatedBranches);
  
  const updatedExistingBranches = { ...existingBranches };
  if (branchQuestions.length > 0) {
    updatedExistingBranches[editingOptionId] = branchQuestions[0]; 
  } else {
    delete updatedExistingBranches[editingOptionId];
  }
  setExistingBranches(updatedExistingBranches);
  
  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: options.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: updatedBranches
    };
    onUpdate(updatedData);
  }
};


const handleDeleteBranch = (optionId) => {
  const updatedExistingBranches = { ...existingBranches };
  delete updatedExistingBranches[optionId];
  
  const updatedBranches = { ...branches };
  delete updatedBranches[optionId];

  setExistingBranches(updatedExistingBranches);
  setBranches(updatedBranches);

  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: options.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: updatedBranches 
    };
    onUpdate(updatedData);
  }
};

const handleCloseModal = () => {
  setBranchModalOpen(false);
  setTimeout(() => {
    setEditingOptionId(null);
  }, 300);
};


  useEffect(() => {
    const loadQuestionFormats = async () => {
      try {
        const response = await getAllQuestionFormats();
        const formats = response.data.formats.map(format => ({
          value: format.id,
          label: format.text
        }));
        setQuestionFormats(formats);
      } catch (error) {
        console.error("Error al cargar los formatos de pregunta:", error);
        setQuestionFormats([]);
      }
    };

    loadQuestionFormats();
  }, []);

  const getQuestionData = () => {
    return {
      isRequired,
      options: options.map(opt => ({ ...opt })), 
      selectedOption,
      selectedOptions: [...selectedOptions], 
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: { ...branches },
      hasOtherOption: hasOtherOption 
    };
  };

const toggleRequired = () => {
  const newRequiredState = !isRequired;
  setIsRequired(newRequiredState);
  
  if (onUpdate) {
    const updatedData = {
      isRequired: newRequiredState, 
      options: options.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: { ...branches },
      hasOtherOption: hasOtherOption 
    };
    onUpdate(updatedData);
  }
};

const handleOptionChange = (id, newText) => {
  const updatedOptions = options.map(option => 
    option.id === id ? { ...option, text: newText } : option
  );
  
  setOptions(updatedOptions);
  
  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: updatedOptions.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: { ...branches },
      hasOtherOption: hasOtherOption 
    };
    onUpdate(updatedData);
  }
};

const handleDeleteOption = (id) => {
    const optionToDelete = options.find(opt => opt.id === id);
  const updatedOptions = options.filter(option => option.id !== id);
  setOptions(updatedOptions);
  // Si se está eliminando una opción "Otros", actualizar el estado
  if (optionToDelete?.isOtherOption) {
    setHasOtherOption(false);
  }
  
  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: updatedOptions.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat,
      branches: { ...branches },
      hasOtherOption: optionToDelete?.isOtherOption ? false : hasOtherOption 
    };
    onUpdate(updatedData);
  }
};

  const handleAddOtherOption = () => {
    
    if (!hasOtherOption) {
      const newId = Math.max(...options.map(opt => opt.id)) + 1;
      
      const addOptionIndex = options.findIndex(opt => opt.isAddOption);
      
      if (addOptionIndex !== -1) {
        const newOptions = [...options];
        newOptions.splice(addOptionIndex, 0, {
          id: newId,
          text: "Otro",
          placeholder: "Otro",
          isAddOption: false,
          isOtherOption: true
        });
        
        setOptions(newOptions);
        setHasOtherOption(true); 
      if (onUpdate) {
        const updatedData = {
          isRequired,
          options: newOptions.map(opt => ({ ...opt })),
          selectedOption,
          selectedOptions: [...selectedOptions],
          uploadedImage,
          imagePreview,
          questionTitle,
          selectedFormat,
          branches: { ...branches },
          hasOtherOption:true
        };
        onUpdate(updatedData);
      }
      }
    }
  };


  const handleAddOption = () => {
    const regularOptions = options.filter(opt => !opt.isAddOption && !opt.isOtherOption);
    const newId = Math.max(...options.map(opt => opt.id)) + 1;
    
    const addOptionIndex = options.findIndex(opt => opt.isAddOption);
    const otherOptionIndex = options.findIndex(opt => opt.isOtherOption);

    if (addOptionIndex !== -1) {
      const newOptions = [...options];

      const insertIndex =  addOptionIndex;

      newOptions.splice(insertIndex, 0, {
        id: newId,
        text: "",
        placeholder: `Opción ${regularOptions.length + 1}`,
        isAddOption: false,
        isOtherOption: false
      });
      
      setOptions(newOptions);
    if (onUpdate) {
      const updatedData = {
        isRequired,
        options: newOptions.map(opt => ({ ...opt })),
        selectedOption,
        selectedOptions: [...selectedOptions],
        uploadedImage,
        imagePreview,
        questionTitle,
        selectedFormat,
        branches: { ...branches },
        hasOtherOption
      };
      onUpdate(updatedData);
    }
    }
  };

  const handleOptionSelect = (id) => {
    setSelectedOption(id);
  };

  const handleMultipleOptionSelect = (id) => {
    setSelectedOptions(prev => {
      if (prev.includes(id)) {
        return prev.filter(optionId => optionId !== id);
      } else {
        return [...prev, id];
      }
    });
  };


const handleFormatChange = (event) => {
  const newFormat = parseInt(event.target.value);
  setSelectedFormat(newFormat);
  
  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: options.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle,
      selectedFormat: newFormat, 
      branches: { ...branches },
      hasOtherOption: hasOtherOption 
    };
    onUpdate(updatedData);
  }
};

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

const handleImageUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    if (!file.type.startsWith('image/')) {
      alert('Por favor, selecciona un archivo de imagen válido.');
      return;
    }

    // Validar tamaño del archivo (ejemplo: máximo 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('La imagen no debe superar los 5MB.');
      return;
    }

    setUploadedImage(file);
    
    const reader = new FileReader();
    reader.onload = (e) => {
      const newImagePreview = e.target.result;
      setImagePreview(newImagePreview);
      
      if (onUpdate) {
        const updatedData = {
          isRequired,
          options: options.map(opt => ({ ...opt })),
          selectedOption,
          selectedOptions: [...selectedOptions],
          uploadedImage: file,
          imagePreview: newImagePreview,
          questionTitle,
          selectedFormat,
          branches: { ...branches }
        };
        onUpdate(updatedData);
      }
    };
    reader.readAsDataURL(file);
  }
};

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

const handleTitleChange = (e) => {
  const newTitle = e.target.value;
  setQuestionTitle(newTitle);
  
  if (onUpdate) {
    const updatedData = {
      isRequired,
      options: options.map(opt => ({ ...opt })),
      selectedOption,
      selectedOptions: [...selectedOptions],
      uploadedImage,
      imagePreview,
      questionTitle: newTitle, 
      selectedFormat,
      branches: { ...branches },
      hasOtherOption: hasOtherOption 
    };
    onUpdate(updatedData);
  }
};

  const handleCopyQuestion = () => {
    if (onCopy) {
      onCopy(getQuestionData());
    }
  };

  const handleDeleteQuestion = () => {
    if (onDelete) {
      onDelete();
    }
  };



  return (
    <div className="flex md:min-w-[738px] min-h-[227px] rounded-lg shadow-[4px_4px_4px_0px_#C4C4C466]">
      <div className="w-4 rounded-tl-lg rounded-bl-lg bg-blue"></div>
      <div className="flex flex-col justify-between w-full gap-4 p-4 bg-white rounded-tr-lg rounded-br-lg">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col items-start w-full gap-4 md:flex-row">
            <input
              className="text-[#080808] h-[40px] w-full md:w-[60%] outline-none  border-b-[1px] focus:border-b-2 focus:border-[#6B7280] border-[#6B7280] p-1 bg-[#E9E9E9] placeholder:text-[#6B7280] font-itcbook placeholder:font-itcbook text-base placeholder:text-base"
              placeholder="Ingrese una pregunta *"
              value={questionTitle}
              onChange={handleTitleChange}
            />
            {/* Botón para subir imagen */}
            
            <div className="flex w-full md:w-[10%] h-[40px] items-center justify-center">
              { !isEditing && (
                <>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleImageUpload}
                accept=".jpg,.jpeg,.png,.webp,.svg,image/jpg,image/jpeg,image/png,image/webp,image/svg+xml"
                className="hidden"
              />
              <img 
                src={createFormImage} 
                className="cursor-pointer" 
                alt="Subir imagen"
                onClick={handleImageClick}
              />
              </>
              )}
            </div>
            
            <div className="flex w-full md:w-[30%] justify-end items-center">
            <SelectField 
              options={questionFormats}
              value={selectedFormat}
              onChange={handleFormatChange}
              placeholder="Seleccionar formato"
              disabled={isEditing}
              
            />
            </div>

          </div>

          {/** mostrar imagen de pregunta si hay */}
          {imagePreview && (
            <div className="flex flex-col items-center gap-2">
              <div className="relative">
                <img 
                  src={imagePreview} 
                  alt="Preview" 
                  className="object-contain w-full h-auto"
                />
                { !isEditing && (
                  <button
                    onClick={handleRemoveImage}
                    className="absolute flex items-center justify-center w-6 h-6 text-sm text-white bg-red-500 rounded-full font-itcbold -top-2 -right-2 hover:bg-red-600"
                    title="Eliminar imagen"
                  >
                    ×
                  </button>
                  )}
              </div>
            </div>
          )}

          {/** pregunta tipo texto */}
          {selectedFormat === 1 && (
            <div className="flex flex-col">
              <p className="w-full text-sm font-itcbook text-gray">
                Texto de respuesta breve
              </p>
              <div className="bg-gray w-1/2 h-[1px]"></div>
            </div>
          )}

          {/** pregunta selección única */}
          {selectedFormat === 2 && (
            <div className="flex flex-col gap-4">
              {options.map((option) => (
                <div key={option.id} className="flex flex-col gap-2">
                  {/* Línea principal de la opción */}
                  <div className="flex items-center gap-2">
                    <div className="flex items-center flex-1 gap-2">
                      {option.isAddOption ? (
                        // Botones de agregar (última fila)
                        <>
                        { !isEditing && (
                        <div className="flex items-center w-full gap-2">
                          <div className={`flex items-center justify-center w-3 h-3 rounded-full border-[#D9D9D9] border-[2px]`}>
                            <span className={`w-1.5 h-1.5 bg-white rounded-full ${selectedOption === option.id ? 'opacity-100' : 'opacity-0'} transition-opacity`}></span>
                          </div>
                          <div className="flex text-sm font-itcmedium text-[#52526C] gap-2">
                            <div 
                              className="cursor-pointer hover:text-blue-light"
                              onClick={() => {
                                handleAddOption();
                                handleOptionSelect(option.id);
                              }}
                            >
                              {option.placeholder}
                            </div>
                            {!hasOtherOption && (
                              <>
                                <span>o</span>
                                <div 
                                  className="cursor-pointer hover:text-blue-light"
                                  onClick={handleAddOtherOption}
                                >
                                  Agregar otros
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        )}
                        </>

                      ) : (
                        // Opciones normales y opción "Otro"
                        <>
                          <div 
                            className={`flex items-center justify-center w-3 h-3 rounded-full border-[#D9D9D9] border-[2px]`}
                            onClick={() => handleOptionSelect(option.id)}
                          >
                            <span className={`w-1.5 h-1.5 bg-white rounded-full ${selectedOption === option.id ? 'opacity-100' : 'opacity-0'} transition-opacity`}></span>
                          </div>
                          
                          {option.isOtherOption ? (
                            <div className="flex items-end w-full gap-2">
                              <p 
                                onClick={() => handleOptionSelect(option.id)}
                                className="text-[#52526C] text-sm font-itcmedium"
                              >
                                Otros: 
                              </p>
                              <div className="bg-[#52526C] w-[150px] h-[1px]"></div>
                            </div>
                          ) : (
                            <input 
                              className={`text-[#52526C] focus:border-b-2 transition-colors duration-200 focus:border-blue outline-none hover:border-b hover:border-gray-400  placeholder:text-[#52526C] placeholder:text-sm placeholder:font-itcmedium text-sm font-itcmedium flex-1
                              ${
                                isEditing && hasOtherOption && option.isOtherOption 
                                  ? 'bg-gray-100 cursor-not-allowed' 
                                  : ''
                              }  
                              `}
                              placeholder={option.placeholder}
                              value={option.text}
                              onChange={(e) => handleOptionChange(option.id, e.target.value)}
                              onClick={() => handleOptionSelect(option.id)}
                              disabled={isEditing && hasOtherOption && option.isOtherOption}
                              readOnly={isEditing && hasOtherOption && option.isOtherOption}
                            />
                          )}
                          
                          {/* Botón para agregar ramificación - SOLO para opciones normales */}
                          {!option.isAddOption && !option.isOtherOption && !hideBranchButtons && (
                            <div className="flex items-center gap-1">
                              {/* Si ya existe rama, mostrar botones de ver y eliminar */}
                              {branches[option.id] && branches[option.id].length > 0 ? (
                                <>
                                  <button
                                    onClick={() => openCreateBranchModal(option.id)}
                                    className="p-1 transition-colors text-blue hover:text-blue-dark"
                                    title="Ver/Editar rama"
                                  >
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.38672 9.5C2.09172 5.66 5.45622 2.75 9.50022 2.75C13.5442 2.75 16.9087 5.66 17.6145 9.5C16.9095 13.34 13.5442 16.25 9.50022 16.25C5.45622 16.25 2.09172 13.34 1.38672 9.5ZM9.50022 13.25C10.4948 13.25 11.4486 12.8549 12.1519 12.1517C12.8551 11.4484 13.2502 10.4946 13.2502 9.5C13.2502 8.50544 12.8551 7.55161 12.1519 6.84835C11.4486 6.14509 10.4948 5.75 9.50022 5.75C8.50566 5.75 7.55183 6.14509 6.84857 6.84835C6.14531 7.55161 5.75022 8.50544 5.75022 9.5C5.75022 10.4946 6.14531 11.4484 6.84857 12.1517C7.55183 12.8549 8.50566 13.25 9.50022 13.25ZM9.50022 11.75C8.90348 11.75 8.33118 11.5129 7.90923 11.091C7.48727 10.669 7.25022 10.0967 7.25022 9.5C7.25022 8.90326 7.48727 8.33097 7.90923 7.90901C8.33118 7.48705 8.90348 7.25 9.50022 7.25C10.097 7.25 10.6693 7.48705 11.0912 7.90901C11.5132 8.33097 11.7502 8.90326 11.7502 9.5C11.7502 10.0967 11.5132 10.669 11.0912 11.091C10.6693 11.5129 10.097 11.75 9.50022 11.75Z"/>
                                    </svg>
                                  </button>
                                  {!isEditing && (
                                  <button
                                    onClick={() => handleDeleteBranch(option.id)}
                                    className="p-1 text-red-500 transition-colors hover:text-red-700"
                                    title="Eliminar todas las ramas"
                                  >
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12.7008 3.60083L12.945 5.29167H16.25C16.4158 5.29167 16.5747 5.35751 16.6919 5.47472C16.8092 5.59193 16.875 5.75091 16.875 5.91667C16.875 6.08243 16.8092 6.2414 16.6919 6.35861C16.5747 6.47582 16.4158 6.54167 16.25 6.54167H15.6092L14.8817 15.0292C14.8375 15.5458 14.8017 15.9708 14.7442 16.3142C14.6858 16.6717 14.5967 16.9917 14.4225 17.2883C14.149 17.7543 13.7424 18.1278 13.255 18.3608C12.945 18.5083 12.6183 18.5692 12.2567 18.5975C11.9092 18.625 11.4833 18.625 10.965 18.625H9.035C8.51667 18.625 8.09083 18.625 7.74333 18.5975C7.38167 18.5692 7.055 18.5083 6.745 18.3608C6.25757 18.1278 5.85098 17.7543 5.5775 17.2883C5.4025 16.9917 5.315 16.6717 5.25583 16.3142C5.19833 15.97 5.1625 15.5458 5.11833 15.0292L4.39083 6.54167H3.75C3.58424 6.54167 3.42527 6.47582 3.30806 6.35861C3.19085 6.2414 3.125 6.08243 3.125 5.91667C3.125 5.75091 3.19085 5.59193 3.30806 5.47472C3.42527 5.35751 3.58424 5.29167 3.75 5.29167H7.055L7.29917 3.60083L7.30833 3.55C7.46 2.89167 8.025 2.375 8.73333 2.375H11.2667C11.975 2.375 12.54 2.89167 12.6917 3.55L12.7008 3.60083ZM8.3175 5.29167H11.6817L11.4683 3.81167C11.4283 3.6725 11.3267 3.625 11.2658 3.625H8.73417C8.67333 3.625 8.57167 3.6725 8.53167 3.81167L8.3175 5.29167ZM9.375 9.25C9.375 9.08424 9.30915 8.92527 9.19194 8.80806C9.07473 8.69085 8.91576 8.625 8.75 8.625C8.58424 8.625 8.42527 8.69085 8.30806 8.80806C8.19085 8.92527 8.125 9.08424 8.125 9.25V13.4167C8.125 13.5824 8.19085 13.7414 8.30806 13.8586C8.42527 13.9758 8.58424 14.0417 8.75 14.0417C8.91576 14.0417 9.07473 13.9758 9.19194 13.8586C9.30915 13.7414 9.375 13.5824 9.375 13.4167V9.25ZM11.875 9.25C11.875 9.08424 11.8092 8.92527 11.6919 8.80806C11.5747 8.19085 11.4158 8.625 11.25 8.625C11.0842 8.625 10.9253 8.69085 10.8081 8.80806C10.6908 8.92527 10.625 9.08424 10.625 9.25V13.4167C10.625 13.5824 10.6908 13.7414 10.8081 13.8586C10.9253 13.4758 11.0842 14.0417 11.25 14.0417C11.4158 14.0417 11.5747 13.9758 11.6919 13.8586C11.8092 13.7414 11.875 13.5824 11.875 13.4167V9.25Z"/>
                                    </svg>
                                  </button>
                                  )}

                                </>
                              ) : (
                                // Si no existe rama y no hay ninguna rama creada, mostrar botón para agregar
                                canShowAddBranchButton(option.id) && !isEditing && (
                                <button
                                  onClick={() => openCreateBranchModal(option.id)}
                                  className="px-1 sm:px-2 py-1 text-[10px] sm:text-xs transition-colors border rounded font-itcbook text-blue border-blue hover:bg-blue hover:text-white"
                                  title="Agregar pregunta ramificada"
                                >
                                  + Rama(s)
                                </button>
                                )
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>  
                      {!option.isAddOption && !isEditing && !(isEditing && hasOtherOption && option.isOtherOption) && (                      <button 
                        className="text-[#52526C] hover:text-red-500 text-lg font-bold cursor-pointer sm:ml-2"
                        onClick={() => handleDeleteOption(option.id)}
                        title="Eliminar opción"
                      >
                        ×
                      </button>
                    )}
                  </div>
                  
                </div>
              ))}
            </div>
          )}
  
          {/**pregunta selección múltiple */}
          {selectedFormat === 3 && (
            <div className="flex flex-col gap-4">
              {options.map((option) => (
                <div key={option.id} className="flex items-center gap-2">
                  <div className="flex items-center flex-1 gap-2">
                    {option.isAddOption ? (
                      // Botones de agregar (última fila)
                      <>
                      { !isEditing && (
                      <div className="flex items-center w-full gap-2">
                        <div 
                          className={`flex items-center justify-center w-3 h-3 border-[#D9D9D9] border-[2px]`}
                        >
                          <span className={`w-1.5 h-1.5 bg-white ${selectedOptions.includes(option.id) ? 'opacity-100' : 'opacity-0'} transition-opacity`}></span>
                        </div>
                        <div className="flex text-sm font-itcmedium text-[#52526C] gap-2">
                          <div 
                            className="cursor-pointer hover:text-blue-light"
                            onClick={() => {
                              handleAddOption();
                              handleMultipleOptionSelect(option.id);
                            }}
                          >
                            {option.placeholder}
                          </div>
                          {!hasOtherOption && (
                            <>
                              <span>o</span>
                              <div 
                                className="cursor-pointer hover:text-blue-light"
                                onClick={handleAddOtherOption}
                              >
                                Agregar otros
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      )}

                      </>
                    ) : (
                      // Opciones normales y opción "Otro"
                      <>
                        <div 
                          className={`flex items-center justify-center w-3 h-3 border-[#D9D9D9] border-[2px]`}
                          onClick={() => handleMultipleOptionSelect(option.id)}
                        >
                          <span className={`w-1.5 h-1.5 bg-white ${selectedOptions.includes(option.id) ? 'opacity-100' : 'opacity-0'} transition-opacity`}></span>
                        </div>
                        
                        {option.isOtherOption ? (
                          <div className="flex items-end w-full gap-2">
                            <p 
                              onClick={() => handleMultipleOptionSelect(option.id)}
                              className="text-[#52526C] text-sm font-itcmedium"
                            >
                              Otros: 
                            </p>
                            <div className="bg-[#52526C] w-[150px] h-[1px]"></div>
                          </div>
                        ) : (
                          <input 
                            className={`text-[#52526C] focus:border-b-2 transition-colors duration-200 focus:border-blue outline-none hover:border-b hover:border-gray-400  placeholder:text-[#52526C] placeholder:text-sm placeholder:font-itcmedium text-sm font-itcmedium flex-1
                              ${
                              isEditing && hasOtherOption && option.isOtherOption 
                                ? 'bg-gray-100 cursor-not-allowed' 
                                : ''
                            }
                            `}
                            placeholder={option.placeholder}
                            value={option.text}
                            onChange={(e) => handleOptionChange(option.id, e.target.value)}
                            onClick={() => handleMultipleOptionSelect(option.id)}
                            disabled={isEditing && hasOtherOption && option.isOtherOption}
                            readOnly={isEditing && hasOtherOption && option.isOtherOption}
                          />
                        )}
                      </>
                    )}
                  </div>
                    {!option.isAddOption && !isEditing && !(isEditing && hasOtherOption && option.isOtherOption) &&(                    <button 
                      className="text-[#52526C] hover:text-red-500 text-lg font-bold cursor-pointer ml-2"
                      onClick={() => handleDeleteOption(option.id)}
                      title="Eliminar opción"
                    >
                      ×
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        
        <div className="flex flex-col gap-2">
          <div className="w-full bg-[#D9D9D9] h-[1px]"></div>
          <div className="flex items-center justify-end w-full">
              <div className="flex items-center gap-3">
                
                <>
                  {(!isEditing &&
                  <img 
                    src={copyForm} 
                    className="cursor-pointer" 
                    alt="Copiar pregunta"
                    onClick={handleCopyQuestion}
                  />
                  )
                  }

                  {showDeleteButton && !isEditing && (
                    <img 
                      src={deleteQuestion} 
                      className="cursor-pointer" 
                      alt="Eliminar pregunta"
                      onClick={handleDeleteQuestion}
                    />
                  )}
                  <div className="h-[26px] w-[1px] bg-[#D9D9D9]"></div>
                </>
               

                  <p className="text-[13px] font-itcmedium text-[#52526C] ">Obligatorio</p>
                  <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                      type="checkbox" 
                      className="sr-only peer" 
                      checked={isRequired}
                      onChange={toggleRequired}
                  />
                  <div className={`w-11 h-6  rounded-full peer 
                      ${isRequired ? 'bg-blue border-[1px] border-[#CCCCCC]' : 'bg-gray-300'} 
                      transition-colors duration-300 ease-in-out`}>
                      <div className={`absolute top-0.5 left-0.5 bg-[#6B7280] border border-[#CCCCCC] rounded-full h-5 w-5 
                      transition-transform duration-300 ease-in-out 
                      ${isRequired ? 'transform translate-x-5 bg-white  ' : ' bg-[#6B7280]'}`}>
                      </div>
                  </div>
                  </label>
              </div>
          </div>
        </div>
      </div>
      <BranchModal
        isOpen={branchModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveBranch}
        initialData={
          editingOptionId && branches[editingOptionId] 
            ? branches[editingOptionId] 
            : null
        }
        mode={
          editingOptionId && branches[editingOptionId] && branches[editingOptionId].length > 0
            ? "edit" 
            : "create"
        }
        isEditing={isEditing}
        key={`${editingOptionId}-${branchModalOpen}`}
      />
    </div>
  );
};

export default QuestionCardAdmin;